// add message based on status code
export const ERROR_MESSAGES = {
    // common error messages
    CONNECTION_ERROR: 'Unable to connect to the database. Please try again later.',
    TIMEOUT_ERROR: 'Request timed out. Please try again.',
    UNAUTHORIZED: 'Unauthorized request.',
    FORBIDDEN: 'Forbidden request.',
    ADMIN_OR_SUPERADMIN_REQUIRED: 'Only Admin or SuperAdmin can perform this action.',
    SUPERADMIN_COMPANY_ID_REQUIRED: 'SuperAdmin must provide companyId in the request body.',
    NOT_FOUND: 'Resource not found.',
    SERVER_ERROR: 'Internal server error.',
    VALIDATION_ERROR: 'Validation error.',
    GENERIC_ERROR: 'Something went wrong.',
    INTERNAL_SERVER_ERROR: 'Internal server error. Please try again later.',
    INVALID_ID: 'Invalid unique id.',
    TOKEN_EXPIRED: 'Token expired.',
    INVALID_TOKEN: 'Invalid token.',
    REQUIRED_FIELD: 'Required field is missing.',
    TOKEN_REQUIRED: 'Token is required.',
    TOKEN_ALREADY_ISSUED: 'Token already issued.',
    ERROR_CALLING_BACKEND: 'Error calling backend.',
    INVALID_REQUEST_BODY: 'Invalid request body.',
    BAD_REQUEST: 'Bad request.',
    MISSING_REQUIRED_FIELDS: 'Missing required fields.',
    FACING_DIFFICULTIES_FETCHING_DATA: 'Facing difficulties fetching data.',
    SCREENING_ID_REQUIRED: 'Screening ID is required.',
    INVALID_JOB_POSTING: 'Invalid job posting.',
    ASSESSMENT_PARAMETER_NOT_FOUND: 'Assessment parameter not found.',
    UNABLE_TO_DELETE_PARAMETER_LINKED_TO_TEMPLATE: 'Unable to delete parameter linked to template.',
    USER_NOT_FOUND: 'User Not Found',
    // job errors
    RECRUITER_NOT_FOUND: 'Recruiter not found.',
    //managers
    MANAGER_NOT_FOUND: 'Manager not found.',
    MANAGER_ALREADY_EXISTS: 'Manager already exists.',
    USER_ALREADY_EXISTS: 'A user with this email already exists in the company.',
    AUTH0_MANAGEMENT_NOT_CONFIGURED:
        'Recruiter creation is not configured. Set AUTH0_M2M_CLIENT_ID, AUTH0_M2M_CLIENT_SECRET, and AUTH0_ISSUER_BASE_URL or AUTH0_DOMAIN.',
    INVALID_EMAIL_DOMAIN: 'Invalid email domain.',
    ASSESSMENT_PARAMETER_ALREADY_EXISTS: 'Competency with this name already exists. Please choose a different name.',
    ASSESSMENT_TEMPLATE_ALREADY_EXISTS: 'Template with this name already exists. Please choose a different name.',

    NAUKRI_JOB_DETAILS_FETCH_ERROR: 'Error while getting Naukri Job details.',

    JOB_APPLICATION_NOT_FOUND: 'Job Application not found.',
    JOB_NOT_FOUND: 'Job not found.',
    MISSING_COMPANY_INFO: 'Missing company information.',

    ERROR_SENDING_OFFER_EMAILS: 'Error sending offer emails.',
    OFFER_TEMPLATE_DOCUMENTS_NOT_FOUND: 'No offer template documents configured for this company and department.',

    'Missing required company configuration for Graph API': 'Missing required company configuration for Graph API.',

    // cronofy errors
    CRONOFY_TOKEN_ERROR: 'Cronofy token error.',
    UNABLE_TO_GET_CALENDARS: 'Unable to get calendar details from Cronofy.',
    UNABLE_TO_GET_DATA: 'Unable to get data from Cronofy.',
    SCHEDULING_SLOT_ERROR: 'Unable to get scheduling slot.',

    UNABLE_TO_UPDATE_CONVERSATION: `Unable to update conversation.`,

    FAIL_TO_SEND_EMAIL: 'Failed to send email.',

    INVALID_JOB_ID: 'Invalid job id.',
    UNABLE_TO_GET_SCHEDULE_DATA: 'Unable to get schedule data.',
    UNABLE_TO_GET_AVAILABILITY: 'Unable to get availability.',

    CAREER_PAGE_NOT_ENABLED: 'Career page is not enabled.',

    //company errors
    COMPANY_NOT_FOUND: 'Company not found.',
    COMPANY_ALREADY_EXISTS: 'Company already exists.',
    MISSING_COMPANY_SLUG: 'Missing company slug.',

    INVALID_GRAPH_RESPONSE: 'Invalid response from Microsoft Graph API',

    // screening interview error messages
    CANDIDATE_NOT_FOUND: 'Candidate not found',
    SCREENING_INTERVIEW_NOT_FOUND: 'Screening Interview not found',
    SCREENING_INTERVIEW_ALREADY_EXISTS: 'Screening Interview already exists',
    SCREENING_CALL_ALREADY_EXISTS: 'Phone screening call already exists for this candidate',
    SCREENING_INTERVIEW_NOT_STARTED: 'Screening Interview not started',

    // interview round error messages
    NO_INTERVIEW_ROUNDS_FOUND: 'No interview rounds found',
    INTERVIEW_NOT_FOUND: 'Interview not found',

    // assessment error messages
    ASSESSMENT_TEMPLATE_NOT_FOUND: 'Assessment template not found',
    ASSESSMENT_PARAMETERS_NOT_FOUND: 'Assessment parameters not found',
    MISSING_TEMPLATE_ID: 'Missing template id',
    PARAMETER_NOT_FOUND: 'Parameter not found',
    PARAMETER_FETCH_ERROR: 'Error fetching parameters',
    MISSING_ASSESSMENT_PARAMETER_ID: 'Missing assessment parameter id',
    TRANSCRIPTION_NOT_FOUND: 'Unable to access the transcript. Please try again.',
    NOTES_NOT_FOUND: 'Unable to access the notes. Please try again.',
    SCREENING_INTERVIEW_ALREADY_COMPLETED: 'Screening Interview already completed',
    UNABLE_TO_UPDATE_QUESTIONS: 'Fail to update questions. Request only allowed until interview is not started',
    INTERVIEW_ROUND_NOT_FOUND: 'Interview round not found',
    ASSESSMENT_PARAMETERS_ALREADY_EXISTS: 'Assessment parameters already exists',
    UNABLE_TO_DELETE_ASSESSMENT_TEMPLATE: 'Unable to delete template. It is used in one or more job postings',
    PARAMETER_DELETED_SUCCESSFULLY: 'Parameter deleted successfully',
    PARAMETER_ALREADY_EXISTS: 'Parameter already exists',
    PARAMETER_CREATED_EXISTS: 'Parameter created exists',
    FAIL_TO_SEND_EMAIL_TO_CANDIDATE: 'Failed to send email to candidate.',
    FAIL_TO_SEND_EMAIL_TO_PANELIST: 'Failed to send email to panelist.',
    FAIL_TO_GENERATE_RESULT: 'Failed to generate result',
    FAILED_TO_UPDATE_INTERVIEW_ROUND: 'Failed to update interview round',
    PLEASE_ATTACH_JOB_DESCRIPTION: 'Please attach job description.',

    // panelist error messages
    PANELIST_DELETED_FAIL: 'Failed to delete panelist.',

    INTERVIEW_ROUND_DELETED_FAIL: 'Failed to delete interview round.',
    SAVE_INTERVIEW_FAIL: 'Failed to save interview.',
    DATERANGE_NOT_SELECTED: 'Please select date range.',
    INTERVIEW_ROUND_NUMBER_NOT_SELECTED: 'Please select interview round number.',
    QUESTIONS_GENERATED_FAIL: 'Failed to generate questions.',
    DATE_NOT_SELECTED: 'Please select proper date.',
    UNABLE_TO_FETCH_JOB_APPLICATION: 'Unable to fetch job application.',
    CANDIDATE_RESUME_PROCESSED_FAILURE: 'Candidate created but we encountered an error while processing the resume. Please try again later.',

    MERGE_CANDIDATE_COMPENSATION_DATA_ERROR: 'Error merging candidate compensation data',
    DELETE_CANDIDATE_DATA_ERROR: 'Error deleting candidate data',

    FAILED_TO_GENERATE_SCREENING_QUESTIONS: 'Failed to generate screening questions',

    // Assessment validation error messages
    NO_ASSESSMENT_TEMPLATE: 'No assessment template configured for this job',
    NO_AI_SCREENING_PARAMETERS: 'No AI screening parameters found in assessment template',
    ASSESSMENT_VALIDATION_FAILED: 'Failed to validate assessment parameters',

    CANDIDATE_EMAIL_NOT_FOUND: 'Candidate email not found',

    FAILED_TO_GENERATE_AVAILABLE_SLOTS: 'Failed to generate available slots',

    INVALID_CLIENT_COMPANY_ENTITY_ID: 'Missing or invalid client_id, company_id, or entity_type',
    INVALID_EMBEDDING: 'Missing or invalid embedding array',
    EMBEDDING_NOT_FOUND: 'Embedding not found',
    EXISTING_MEETING_NOT_FOUND: 'Existing meeting not found',
    INTERVIEW_ALREADY_COMPLETED: 'Meeting already completed',
    RECORDING_PROCESSING_ERROR: 'Error processing recording. Please try again later.',
    FAILED_TO_GENERATE_AZURE_TOKEN: 'Failed to generate Azure token',
    NO_MUTUAL_SLOTS: 'No mutual slots found across all panelists. Please coordinate to select common timeslots before confirming.',
}

export const SUCCESS_MESSAGES = {
    TRANSCRIPTION_SAVED_SUCCESSFULLY: 'Transcription and summary saved/update successfully',
    FEEDBACK_SAVED_SUCCESSFULLY: 'Feedback saved/update successfully',
    DATA_FETCHED_SUCCESSFULLY: 'Data fetched successfully',
    SUMMARY_SAVED_SUCCESSFULLY: 'Summary saved successfully',
    SCREENING_LINK_SENT: 'Screening interview link sent successfully',
    SCREENING_INTERVIEW_STARTED_SUCCESS: 'Screening Interview started successfully',
    ASSESSMENT_PARAMETER_FETCH_SUCCESS: 'Assessment parameters fetched successfully',
    SUCCESSFULLY_UPDATED_TRANSCRIPTION: 'Successfully updated transcriptions',
    ASSESSMENT_PARAMETER_CREATE_SUCCESS: 'Assessment parameter created successfully',
    ASSESSMENT_PARAMETER_COPY_SUCCESS: 'Competency copied successfully',
    ASSESSMENT_PARAMETER_DELETE_SUCCESS: 'Assessment parameter deleted successfully',
    ASSESSMENT_TEMPLATE_UPDATED_SUCCESS: 'Assessment template updated successfully',
    ASSESSMENT_TEMPLATE_FETCH_SUCCESS: 'Assessment template fetched successfully',
    ASSESSMENT_TEMPLATE_DELETED_SUCCESS: 'Assessment template deleted successfully',
    NO_CANDIDATES_FOUND: 'No candidates found',
    ASSESSMENT_PARAMETER_UPDATE_SUCCESS: 'Assessment parameter updated successfully',

    JOB_APPLICATION_DELETED_SUCCESS: 'Job Application deleted successfully',
    JOB_POSTING_DELETE_SUCCESS: 'Job posting deleted successfully',

    NOTE_UPDATE_SUCCESS: 'Note updated successfully',

    CHART_ORDER_UPDATED: 'Chart order updated successfully',

    NOTE_FETCH_SUCCESS: 'Notes fetched successfully',
    NOTE_DELETE_SUCCESS: 'Note deleted successfully',

    NOTE_CREATED_SUCCESS: 'Note created successfully',

    SLOT_BOOKING_SUCCESS: 'Slot booking successful',

    JOB_APPLICATION_CREATED: 'Job application created successfully.',

    WHATSAPP_MESSAGE_SENT_SUCCESS: 'WhatsApp message sent successfully.',

    AVAILABLE_SLOTS_GENERATED: 'Available slots generated successfully.',

    // cronofy success messages
    ELEMENT_TOKEN_GENERATED: 'Element token generated successfully',
    SLOT_BOOKING_URL_SENT_TO_CANDIDATE: 'Slot booking URL sent to candidate.',
    SLOT_BOOKED_SUCCESSFULLY: 'Slot booked successfully.',
    CANDIDATE_RESUME_PROCESSED: 'Candidate resume processed successfully',

    TRANSCRIPTION_FETCHED_SUCCESSFULLY: 'Transcription fetched successfully',
    TRANSCRIPT_UPDATED_SUCCESSFULLY: 'Transcript updated successfully',
    MANAGER_VERIFIED_SUCCESSFULLY: 'Manager verified successfully',
    AUTHORIZATION_URL_SENT_SUCCESSFULLY: 'Authorization URL sent successfully',
    MANAGER_DATA_FETCHED_SUCCESSFULLY: 'Manager data fetched successfully.',
    CANDIDATES_QUEUED_SUCCESSFULLY: 'Candidates queued for processingsuccessfully',
    CANDIDATE_CREATED_SUCCESS: 'Candidate created successfully',
    CANDIDATE_UPDATED_SUCCESS: 'Candidate updated successfully',
    CANDIDATE_DELETED_SUCCESS: 'Candidate deleted successfully',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard.',
    CANDIDATE_FETCHED_SUCCESSFULLY: 'Candidate fetched successfully',
    ADD_SUCESS_TO_JOB: 'Candidate added to job successfully',
    JOB_POSTING_CREATE_SUCCESS: 'Job posting created successfully',
    USER_CREATE_SUCCESS: 'User created successfully',
    USER_FETCH_SUCCESS: 'User fetched successfully',
    USER_UPDATE_SUCCESS: 'User updated successfully',
    DEPARTMENTS_MAP_SUCCESS: 'Departments mapped successfully',
    USER_PASSWORD_RESET_SUCCESS: 'Password reset successfully',

    USER_LIST_FETCH_SUCCESS: 'User list fetched successfully',
    USERS_ENABLE_SUCCESS: 'User(s) enabled successfully',
    USERS_DISABLE_SUCCESS: 'User(s) disabled successfully',

    PANELIST_DELETED_SUCCESS: 'Panelist deleted successfully',

    INTERVIEW_ROUND_DELETED_SUCCESS: 'Interview round deleted successfully',
    INTERVIEW_ROUND_UPDATED_SUCCESS: 'Interview round updated successfully',
    QUESTIONS_GENERATED_SUCCESS: 'Questions generated successfully',
    SCREENING_INTERVIEW_UPDATED_SUCCESS: 'Screening Interview updated successfully',

    SCREENING_INTERVIEW_CREATED_SUCCESS: 'Screening Interview created successfully',

    ASSESSMENT_TEMPLATE_CREATED: 'Assessment template created successfully',
    MANAGER_DELETED_SUCCESSFULLY: 'Manager deleted successfully',

    JOBS_FETCHED_SUCCESS: 'Jobs fetched successfully',
    COMPANY_DETAILS_FETCHED_SUCCESS: 'Company details fetched successfully',

    EMBEDDING_STORE_SUCCESS: 'Embedding stored successfully',
    EMBEDDING_FETCH_SUCCESS: 'Embedding retrieved successfully',
    RECORDING_PROCESSED_SUCCESSFULLY: 'Recording processed successfully',
    RECORDING_PROCESSING_STATUS_UPDATED: 'Recording processing status updated successfully',
    PROCTORING_EVENTS_UPDATED: 'Proctoring events updated successfully',
    PROCTORING_EVENTS_FETCH_SUCCESS: 'Proctoring events fetched successfully',
    INTERVIEW_EVENTS_UPDATED: 'Interview events updated successfully',
    INTERVIEW_EVENTS_FETCH_SUCCESS: 'Interview events fetched successfully',
    TOKEN_GENERATED_SUCCESSFULLY: 'Token generated successfully',
    TOKEN_RESET_SUCCESSFULLY: 'Token reset successfully',
}
